import { createAsyncThunk } from '@reduxjs/toolkit';
import AssignmentApi from '@infrastructure/assignment-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { translate } from '@application/common/helpers/translate';
import { addSuccessNotification } from '../common/notificationSlice';
export const addAssignmentAsync = createAsyncThunk('assignment/add', async (assignment, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.addAssignment(assignment);
        dispatch(addSuccessNotification(translate('assignment.assignmentAddedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateAssignmentAsync = createAsyncThunk('assignment/UpdateAssignment', async (assignment, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.updateAssignment(assignment);
        dispatch(addSuccessNotification(translate('assignment.assignmentUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentByStatusAsync = createAsyncThunk('assignment/getByStatus', async (status, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.getAssignmentsByStatus(status);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentByApprovedTimsheetAsync = createAsyncThunk('assignment/getAssignmentsWithApprovedTimeSheet', async (_, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.getAssignmentsWithApprovedTimeSheet();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentByStatusWithReasonAsync = createAsyncThunk('assignment/getByStatusWithReason', async (status, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.getAssignmentsByStatusWithReason(status);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentsByMultipleStatusesAsync = createAsyncThunk('assignment/getByMultipleStatuses', async (statuses, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignmentsByMultipleStatuses(statuses);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getFreelancerAssignmentsAsync = createAsyncThunk('assignment/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignments();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getAssignmentDetailByIdAsync = createAsyncThunk('assignment/getDetailById', async (assignmentId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignmentDetailById(assignmentId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const getAssignmentByIdAsync = createAsyncThunk('assignment/GetAssignmentById', async (assignmentId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await AssignmentApi.getAssignmentById(assignmentId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateAssignmentContractAsync = createAsyncThunk('assignment/updateAssignmentContract', async (contract, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.updateAssignmentContract(contract);
        dispatch(addSuccessNotification(translate('assignment.assignmentUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const extendAssignmentAsync = createAsyncThunk('assignment/ExtendAssignment', async ({ assignmentId, extendedDate }, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.extendAssignment(assignmentId, extendedDate);
        dispatch(addSuccessNotification('Contract extended date has been successfully saved'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const terminateAssignmentAsync = createAsyncThunk('assignment/TerminateAssignment', async (assignmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.terminateAssignment(assignmentId);
        dispatch(addSuccessNotification('Contract has been successfully terminated'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
export const updateAssignmentContractEndDateAsync = createAsyncThunk('assignment/updateAssignmentContractEndDate', async (contract, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await AssignmentApi.updateAssignmentContractEndDate(contract);
        dispatch(addSuccessNotification(translate('assignment.assignmentUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        const apiError = getErrorPayload(error);
        return rejectWithValue(apiError);
    }
});
